import {shortenUrl} from './shortenUrl';

export const firebaseService = {
  shortenUrl,
};

